/** Preset swatches for new tags */
export const TAG_COLOR_PRESETS = [
  '#5b21b6',
  '#2563eb',
  '#059669',
  '#d97706',
  '#dc2626',
  '#db2777',
  '#0891b2',
  '#4f46e5',
  '#65a30d',
  '#ea580c'
];

export const DEFAULT_TAG_COLOR = TAG_COLOR_PRESETS[0];
